export interface NewAddress {
    address_line_1: string;
    address_line_2?: string;
    city: string;
    state: string;
    zip_code: string;
    country?: string;
    is_main_address?: string;
};

export const newAddressInitialValues: NewAddress = {
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    zip_code: "",
    country: "US"
};

export interface Address {
    id?: number;
    address_line_1?: string;
    address_line_2?: string;
    city?: string;
    state?: string;
    zip_code?: string;
    country?: string;
    is_main_address?: string;
    client_id?: number;
    delete_at?: Date;
}

export interface EditAddress {
    id?: number;
    address_line_1?: string;
    address_line_2?: string;
    city?: string;
    state?: string;
    zip_code?: string;
    country?: string;
    is_main_address?: string;
}

export interface LeadAddress {
    address: string;
    city: string;
    state: string;
    zip_code: string;
    country: string;
}